import React from "react";

// Very light markdown rendering: **bold**, bullets, line breaks.
export default function MessageText({ text }) {
  const lines = (text || "").split("\n");
  return (
    <div className="space-y-1">
      {lines.map((ln, i) => {
        if (!ln.trim()) return <div key={`blank-${i}`} className="h-1" />;
        const bullet = ln.trim().match(/^([-*•]|\d+\.)\s+(.*)/);
        const content = bullet ? bullet[2] : ln;
        const parts = content.split(/(\*\*[^*]+\*\*)/g).map((p, k) =>
          p.startsWith("**") && p.endsWith("**")
            ? <strong key={`b-${i}-${k}`} className="text-white">{p.slice(2, -2)}</strong>
            : <span key={`s-${i}-${k}`}>{p}</span>
        );
        return (
          <div key={`ln-${i}`} className={bullet ? "pl-3 relative" : ""}>
            {bullet && <span className="absolute left-0 top-1.5 w-1 h-1 bg-[#00E5FF] rounded-full" />}
            {parts}
          </div>
        );
      })}
    </div>
  );
}

export function formatTime(iso, locale = "it-IT") {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}
